import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/shared/services/service';
import { RandomTrackResponse } from '../../shared/models/tracks-sfx/random-track-response.model';
import { HttpClient } from '@angular/common/http';
import { Track } from '../../shared/models/tracks-sfx/track.model';
import { TracksService } from '../../shared/services/tracks.service';

@Injectable({
  providedIn: 'root'
})
export class RandomTrackService extends Service {

  private randomTracks: Track[] = [];
  private randomSoundEffects: Track[] = [];

  constructor(
    http: HttpClient,
    private trackService: TracksService
  ) {
    super(http);
  }

  getTrack(): Observable<Track> {
    return new Observable<Track>((observer) => {
      if (this.randomTracks.length === 0) {
        this.trackService.getRandom().subscribe(response => {
          this.randomTracks = response.tracks;
          this.randomSoundEffects = response.sfxs;
          observer.next(this.randomTracks.shift());
          observer.complete();
        });
      } else {
        observer.next(this.randomTracks.shift());
        observer.complete();
      }
    });
  }

  getSoundEffect(): Observable<Track> {
    return new Observable<Track>((observer) => {
      if (this.randomSoundEffects.length === 0) {
        this.trackService.getRandom().subscribe(response => {
          this.randomTracks = response.tracks;
          this.randomSoundEffects = response.sfxs;
          observer.next(this.randomSoundEffects.shift());
          observer.complete();
        });
      } else {
        observer.next(this.randomSoundEffects.shift());
        observer.complete();
      }
    });
  }

}
